<mm-spinner [loading]="tableState$"></mm-spinner>
<div class='errorMsgContainer' *ngIf="(tableState$ | async)?.hasError">
    <div class='documentWarning-icon'></div>
    <div class='main-msg'>Can’t load transactions</div>
    <div class='secondary-msg'>Sorry for the inconvenience. Please try again later.</div>
     <a (click)="refreshTable()" class='refresh-msg'>Refresh page</a>
</div>
<ng-template [ngIf]="!(tableState$ | async)?.hasError && (tableState$ | async)?.hasEmptyResponse && !(tableState$ | async)?.loading">
    <div class='errorMsgContainer'>
        <div class='main-msg'>{{noRowsMessageTemplates.transactionsHeader}}</div>
    </div>
</ng-template>
